export class SensorGroup {
    id: string;
    name: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;

    private spanishNames?: Record<string, string> = {
        id: "identificador",
        name: "nombre",
        createdAt: "creado en",
        updatedAt: "actualizado en",
        createdBy: "creado por",
        updatedBy: "actualizado por",
    };

    constructor(data?: Partial<SensorGroup>) {
        this.id = data?.id ?? "";
        this.name = data?.name ?? "";
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
        this.createdBy = data?.createdBy ?? "";
        this.updatedBy = data?.updatedBy ?? "";
    }

    getSpanishName(propertyName: string): string {
        if (this.spanishNames && this.spanishNames[propertyName]) {
            return this.spanishNames[propertyName];
        }
        return propertyName;
    }

    toPlainObject(): Record<string, any> {
        return {
            id: this.id,
            name: this.name,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
        };
    }
}
